// extracted by mini-css-extract-plugin
export var label = "_ds-1";
export var reminder = "_ds-0";